import $ from 'jquery';

$( document ).ready( function() {
	$( '.toggle-item-digital-codes' ).click( function() {
		const itemId = $( this ).attr( 'data-item-id' );
		$( '.item-digital-codes-' + itemId ).slideToggle();
	} );
} );
